import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaJs, FaReact, FaNodeJs, FaPython, FaLock } from 'react-icons/fa';
import {SiFlutter, SiMysql } from 'react-icons/si';
import { SiHtml5 } from 'react-icons/si';
import { SiCss3 } from 'react-icons/si';
import { SiShopify } from 'react-icons/si';


import './Skills.css';

const skillsData = [
  { name: 'Flutter', icon: <SiFlutter className="skill-svg" /> },
  { name: 'HTML', icon: <SiHtml5 className="skill-svg" /> },
  { name: 'CSS', icon: <SiCss3 className="skill-svg" /> },
  { name: 'JavaScript', icon: <FaJs className="skill-svg" /> },
  { name: 'Shopify', icon: <SiShopify className="skill-svg" /> },
  { name: 'React', icon: <FaReact className="skill-svg" /> },
  { name: 'Node.js', icon: <FaNodeJs className="skill-svg" /> },
  { name: 'MySQL', icon: <SiMysql className="skill-svg" /> },
  { name: 'Python', icon: <FaPython className="skill-svg" /> },
  { name: 'Cybersecurity', icon: <FaLock className="skill-svg" /> },
];

const Skills = () => {
  useEffect(() => {
    if (window.location.hash === '#skills') {
      document.getElementById('skills')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <section id="skills" className="skills-section">
      <div className="container">
        <motion.h2
          className="skills-title"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          My Technical Skills
        </motion.h2>

        <motion.p
          className="skills-description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          A comprehensive list of technologies I have worked with, covering programming languages, frameworks, and cybersecurity expertise.
        </motion.p>

        <div className="skills-grid">
          {skillsData.map((skill, index) => (
            <motion.div
              key={index}
              className="skill-card"
              whileHover={{ scale: 1.1, boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)" }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              {skill.icon}
              <p className="skill-name">{skill.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
